import React, { Component } from "react";
import { Button } from "@mui/material";
import { Payment } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";

interface props {
  loading: boolean;
  disabled: boolean;
  onPress: () => any;
}

export default class PayOrderBtn extends Component<props, {}> {
  render() {
    return (
      <Button
        onClick={this.handlePress}
        disabled={this.getDisabled()}
        variant="contained"
        color="primary"
        startIcon={this.getIcon()}
        style={{ padding: "3%", width: "100%" }}
      >
        {this.getText()}
      </Button>
    );
  }

  getText = (): string => {
    return this.props.loading
      ? "Elaboro la richiesta di ordine"
      : "Effettua ordine";
  };

  getIcon = (): any => {
    if (this.props.disabled) {
      return <Payment />;
    }
    return this.props.loading ? (
      <CircularProgress size={28} style={{ color: "#fff" }} />
    ) : (
      <Payment />
    );
  };

  getDisabled = (): boolean => {
    return this.props.disabled;
  };

  handlePress = () => {
    if (this.props.loading) {
      return;
    } else {
      this.props.onPress();
    }
  };
}
